import identity from "./identity";
import memoizeWith from "./memoizeWith";

const memoize = memoizeWith(identity);
export default memoize;
